var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscountTag02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6641 13.333H14.6841M14.669 21.333H14.689",
    stroke: "#E26E6A",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33594 17.333H20.0026",
    stroke: "#E26E6A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3359 6.66699C24.4405 6.66699 25.3359 7.56242 25.3359 8.66699C25.3359 9.77156 24.4405 10.667 23.3359 10.667C22.2314 10.667 21.3359 9.77156 21.3359 8.66699C21.3359 7.56242 22.2314 6.66699 23.3359 6.66699Z",
    stroke: "#E26E6A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69637 14.8589C2.35884 16.3527 2.33007 18.6065 3.55761 20.1919C5.99355 23.3381 8.65972 26.0042 11.8058 28.4401C13.3913 29.6677 15.645 29.6389 17.1389 28.3014C21.1946 24.6699 24.9087 20.8749 28.4933 16.7042C28.8477 16.2919 29.0693 15.7866 29.119 15.2451C29.339 12.851 29.791 5.95322 27.9178 4.07998C26.0445 2.20674 19.1467 2.65869 16.7526 2.87867C16.2111 2.92843 15.7058 3.1501 15.2934 3.50447C11.1229 7.08894 7.32781 10.8031 3.69637 14.8589Z",
    stroke: "#E26E6A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountTag02);
export default __webpack_public_path__ + "static/media/discount-tag-02.97a415cbdbaf00d60ce7b2b7f3d88705.svg";
export { ForwardRef as ReactComponent };